export enum Recommended {
    compact,
    consistent,
    scattered,
    freeDays,
    earlyStart,
    lateStart,
    earlyEnd,
    lateEnd,
}